module.exports = __webpack_public_path__ + "resources/img/img_dvision2_m.b81390a424b78218212b73b864e376ac.png";